let index = {
    DashboardMaster: "dashbord",
    AdminMaster: "adminUser",
    RoleMaster: "roleMaster",
    LanguageMaster: "languageMaster",
    CategoryMaster: "categoryMaster",
    CompanyMaster: "companyMaster",
    TagMaster: "tagMaster",
    ErrorMaster: "errorMaster",
    AppUserMaster: "appUserMaster",
    ModuleMaster: "moduleMaster",
    PermissionMaster: "permisionMaster",
    MFMaster: "mutualFundMaster",
    OrderMaster: "orderMaster",
    SettingMaster: "settingMaster",
    MainMaster: "mainMaster",
    MFFlowMaster: "MFFlowMaster",
    MFUserStatus: "MFUserStatus"

}
export default index